import React, { useContext, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import AppContext from '@context';
import { CancelJourneyPayloadInterface } from '@interface/journeys';
import useLoadJourneys from '@hooks/useLoadJourneys';
import { cancelJourney } from '@services/journeys';
import FieldObservation from './FieldObservation';
import FieldRadios from './FieldRadios';
import NotificationError from './NotificationError';
import { FormPropsInterface } from './FormTypes';

function Form({ innerRef, hasLoading }: FormPropsInterface) {
  const { clearErrors, handleSubmit, setValue, watch } = useFormContext();
  const {
    state: { ui },
    dispatch,
  } = useContext(AppContext);
  const {
    journeyId,
    depositFee: { tagLabel },
  } = ui.DialogCancelJourney;
  const reasonValue = watch('reason');
  const [isLoading, setIsloading] = useState(false);
  const { fetchJourneys } = useLoadJourneys('lazy');

  function handleNotificationShow() {
    if (tagLabel) {
      window.dispatchEvent(
        new CustomEvent('notificationShow', {
          detail: {
            isShow: true,
            heading: 'Sua viagem foi cancelada!',
            message: 'Vamos avisar o motorista.',
            severity: 'success',
          },
        }),
      );
      return;
    }
    window.dispatchEvent(
      new CustomEvent('notificationShow', {
        detail: {
          isShow: true,
          heading: 'Viagem cancelada com sucesso!',
          severity: 'success',
        },
      }),
    );
  }

  function handleCancelJourney(payload: CancelJourneyPayloadInterface) {
    if (!isLoading) {
      setIsloading(true);
      hasLoading(true);

      cancelJourney({ id: journeyId, payload })
        .then(() => {
          handleNotificationShow();
          fetchJourneys({
            page: 1,
          });

          dispatch({
            type: 'ui_dialogCancelJourney_set_show',
            payload: {
              isShow: false,
              journeyId: '',
              depositFee: {
                tagLabel: '',
              },
            },
          });
        })
        .catch(() => {
          window.dispatchEvent(
            new CustomEvent('notificationShow', {
              detail: {
                isShow: true,
                heading: 'Erro ao cancelar a viagem!',
                severity: 'error',
              },
            }),
          );
        })
        .finally(() => {
          setIsloading(false);
          hasLoading(false);
        });
    }
  }

  useEffect(() => {
    setValue('observations', '');
    clearErrors();
  }, [reasonValue]);

  return (
    <form
      data-testid="form-cancelJourney"
      ref={innerRef}
      onSubmit={handleSubmit((data) =>
        handleCancelJourney(data as CancelJourneyPayloadInterface),
      )}
    >
      <FieldRadios />
      <FieldObservation />
      <NotificationError />
    </form>
  );
}

export default Form;
